import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "qr-dialog__loading"
}
const _hoisted_2 = {
  key: 1,
  class: "qr-dialog__content"
}
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "qr-dialog__hint" }

import GlobalService from "@/services/global-service";
import useStore from "@/stores";
import { useAppNav } from "@/composables/useAppNav";
import { nextTick, onBeforeUnmount, ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppToolbar',
  setup(__props) {

const accountMenuOpen = ref(false);

async function logOut(): Promise<void> {
  accountMenuOpen.value = false;
  await nextTick();
  await session.reAuth(true);
}
const { showTopNavItems, isGuest, routeName, visibleItems } = useAppNav();

const store = useStore();
const session = store.session;
const qrStore = store.qr;

const languages = [
  { code: "en", name: "English" },
  { code: "nl", name: "Nederlands" },
  { code: "fr", name: "Français" }
];

async function go(name: string): Promise<void> {
  await GlobalService.router().routeTo(name);
}

function changeLanguage(language: string): void {
  session.language = language;
  GlobalService.translator().setLanguage(language);
}

onBeforeUnmount((): void => {
  qrStore.revokeQrCodeUrl();
});

return (_ctx: any,_cache: any) => {
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_app_bar, { color: "primary" }, {
      append: _withCtx(() => [
        (_unref(isGuest))
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              icon: "mdi-qrcode",
              loading: _unref(qrStore).qrLoading,
              disabled: _unref(qrStore).qrLoading,
              onClick: _unref(qrStore).openQrDialog
            }, null, 8, ["loading", "disabled", "onClick"]))
          : _createCommentVNode("", true),
        _createVNode(_component_v_menu, null, {
          activator: _withCtx(({ props }) => [
            _createVNode(_component_v_btn, _mergeProps({ icon: "mdi-web" }, props), null, 16)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_v_list, null, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(languages, (language) => {
                  return _createVNode(_component_v_list_item, {
                    key: language.code,
                    onClick: ($event: any) => (changeLanguage(language.code))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(language.name), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                }), 64))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_menu, {
          modelValue: accountMenuOpen.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((accountMenuOpen).value = $event)),
          location: "bottom end",
          width: "220"
        }, {
          activator: _withCtx(({ props }) => [
            _createVNode(_component_v_btn, _mergeProps({
              icon: "mdi-dots-vertical",
              "aria-label": "Menu"
            }, props), null, 16)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_v_list, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item, {
                  "prepend-icon": "mdi-logout",
                  onClick: logOut
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(GlobalService).translator().trans("general.menu.log_out")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_app_bar_title, null, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode("Be-Housing Guest App", -1)
          ]))]),
          _: 1
        }),
        (_unref(showTopNavItems))
          ? (_openBlock(), _createBlock(_component_v_tabs, {
              key: 0,
              "model-value": _unref(routeName),
              "align-tabs": "center",
              class: "guest-tabs"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visibleItems), (item) => {
                  return (_openBlock(), _createBlock(_component_v_tab, {
                    key: item.route,
                    value: item.route,
                    onClick: ($event: any) => (go(item.route))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        start: "",
                        icon: item.icon
                      }, null, 8, ["icon"]),
                      _createTextVNode(" " + _toDisplayString(item.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["value", "onClick"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["model-value"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: _unref(qrStore).qrDialogOpen,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(qrStore).qrDialogOpen) = $event)),
      "max-width": "360"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { rounded: "xl" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(GlobalService).translator().trans("reservation.qr_code.title")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                (_unref(qrStore).qrLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                      _createVNode(_component_v_progress_circular, { indeterminate: "" })
                    ]))
                  : (_unref(qrStore).qrCodeUrl)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("img", {
                          src: _unref(qrStore).qrCodeUrl,
                          alt: _unref(GlobalService).translator().trans('reservation.qr_code.title')
                        }, null, 8, _hoisted_3),
                        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(GlobalService).translator().trans("reservation.qr_code.hint")), 1)
                      ]))
                    : (_openBlock(), _createBlock(_component_v_alert, {
                        key: 2,
                        type: "info",
                        variant: "tonal",
                        density: "compact"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(GlobalService).translator().trans("reservation.qr_code.not_available")), 1)
                        ]),
                        _: 1
                      }))
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: _unref(qrStore).closeQrDialog
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(GlobalService).translator().trans("general.login.close")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})